// extracted by mini-css-extract-plugin
export default {"mainContainer":"offline_mainContainer__bLjEA","errorContainer":"offline_errorContainer__7UoLN","errorMessage":"offline_errorMessage__OWf6q"};